import React, {useEffect, useRef, useState} from 'react';
import logo from "../logo.svg";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";

import i18n from "../resources/i18nSetup";
import {addDays, checkValidDate, ValidationRule} from "../helpers/validationRule";
import {UseValidationForm} from "./useValidationForm";
import {Box, Button, Grid, Typography} from "@mui/material";
import Loading from "../helpers/loading";
import {PUBLIC_TRANSPORT_LIMIT_DATE, RESPONSE_STATUS} from "../constants";

import {IssueTickets, updateIndexPage} from "../redux/reducers/voucherPortalFormReducer";

function PersonalDetails(props) {

  let initialValues = {};
  const dispatch = useDispatch();
  const [personsInfo, setPersonsInfo] = useState([]);
  const mountedRef = useRef();
  const [validations, setValidations] = useState();
  var link = <a target="_blank" href={"https://www.l.de/datenschutz/verkehrsbetriebe/ticketabruf"}>{i18n.t("linkedString")}</a>;

  const voucherValidationResponse = useSelector((state) =>
    state.VoucherPortalFormReducer.voucherValidation.response
  );

  const issueTicketsStatus = useSelector((state) =>
    state.VoucherPortalFormReducer.IssueTickets.status
  );

  const  classes = useSelector((state) =>
    state.VoucherPortalFormReducer.classes
  );

  const submitPersonsDetails = () => {
    mountedRef.current = true
   var passengers = {passengers:personsInfo}
    dispatch(IssueTickets(passengers))

  }

  const {handleSubmit, handleChange, data, errors} = UseValidationForm({
    onSubmit: submitPersonsDetails,
    validations: validations,
    initialValues: initialValues
  });
  useEffect(() => {
     if (issueTicketsStatus  === RESPONSE_STATUS.Succeeded &&   mountedRef.current){
       dispatch(updateIndexPage(2))
     }
  }, [issueTicketsStatus]);

  useEffect(() => {
    var validator = {}
    let numberTickets = voucherValidationResponse.tickets_amount
    for (let j = 0; j < numberTickets; j++) {
      validator['person_' + j + '_fName'] = {
        pattern: {
          value: ValidationRule.patternLetters.value,
          messageKey: 'errorInvalidTextInput',
        },
        specialCharacters: {
          value: ValidationRule.specialCharacters.value,
          messageKey: 'errorInvalidTextInput',
        },
        required: ValidationRule.required
      }
      validator['person_' + j + '_lName'] = {
        pattern: {
          value: ValidationRule.patternLetters.value,
          messageKey: 'errorInvalidTextInput',
        },
        specialCharacters: {
          value: ValidationRule.specialCharacters.value,
          messageKey: 'errorInvalidTextInput',
        },
        required: ValidationRule.required
      }
      validator['person_' + j + '_dtBorn'] = {
        required: ValidationRule.required,
        custom: {
          isValid: (value) => moment(value).isSameOrBefore(moment()) ,
          messageKey: 'IncorrectDateOfBirth',
        },
      }
      validator['person_' + j + '_date_public_transport'] = {
        required: ValidationRule.required,
        custom: {
          isValid: (value) => checkValidDate(new Date(),addDays(13),value) ,
          messageKey: (i18n.t('rangeDateError', {LimitDays: PUBLIC_TRANSPORT_LIMIT_DATE}))
        },
      }
    }
    setValidations({
      ...validations,
      ...validator
    });
    let persons = []
    for (let j = 0; j < numberTickets; j++) {
      persons.push({first_name: "", last_name: "",birth_date:"",date_public_transport:""})
    }
    setPersonsInfo(persons)
  }, [voucherValidationResponse]);

  const handleChangePersonInfo = (index, keyField, key, sanitizeFn) => (
    e,
  ) => {
    const value = sanitizeFn ? sanitizeFn(e.target.value) : e.target.value;
    personsInfo[index][keyField] = value
    setPersonsInfo(personsInfo)
    handleChange(key, sanitizeFn)(e)
  };

  return (
    <Grid item xs={12}>
      <form  noValidate onSubmit={handleSubmit}  >
        <Grid container  direction={"row"} spacing={1}>
          <Grid item xs={12}>
            <h2 class={classes && classes.h2_classes}>{i18n.t('personalDetailsTitle')}</h2>
          </Grid>
          <Grid item xs={12}>
            {personsInfo.map((person, index) => (
              <Box key={index}>
            <Grid container   direction={"row"} x>
              <Grid item xs={12} mb={1}  sm={5.9} lg={5.9} xl={5.9}>
                <label class={classes && classes.label_classes}>{i18n.t('firstName')}</label>
                <input
                  style={{ width: '100%'}}
                  class={classes && classes.input_classes.regular}
                  type="text"
                  name="person_${index}_fName"
                  onChange={handleChangePersonInfo(index, `first_name`, `person_${index}_fName`)}
                  onBlur={handleChangePersonInfo(index, `first_name`, `person_${index}_fName`)}
                  value={data[`person_${index}_fName`]}
                />
                {errors[`person_${index}_fName`] &&
                <p class={classes && classes.p_classes.error}>{i18n.t(errors[`person_${index}_fName`])}</p>
                }
              </Grid>
              <Grid item xs={0}  sm={0.2} lg={0.2} xl={0.2}>
              </Grid>
              <Grid item  xs={12}  mb={1}   sm={5.9} lg={5.9} xl={5.9}>
                <label class={classes && classes.label_classes}>{i18n.t('lastName')}</label>
                <input
                  style={{ width: '100%' }}
                  class={classes && classes.input_classes.regular}
                  type="text"
                  name={`person_${index}_lName`}
                  onChange={handleChangePersonInfo(index, `last_name`, `person_${index}_lName`)}
                  onBlur={handleChangePersonInfo(index, `last_name`, `person_${index}_lName`)}
                  value={data[`person_${index}_lName`]}
                />
                {errors[`person_${index}_lName`] &&
                <p class={classes && classes.p_classes.error}>{i18n.t(errors[`person_${index}_lName`])}</p>
                }
              </Grid>
              <Grid container  mb={1}    direction={"row"} spacing={0}>
                <Grid item xs={5.9}>
                  <label class={classes && classes.label_classes}>{i18n.t('dateBirth')}</label>
                  <input
                    style={{ width: '100%' }}
                    class={classes && classes.input_classes.datePicker}
                    type="date"
                    placeholder={i18n.t('dateBirth')}
                    name="dateBirth"
                    max={new Date().toISOString().split('T')[0]}
                    onChange={handleChangePersonInfo(index, `birth_date`, `person_${index}_dtBorn`)}
                    onBlur={handleChangePersonInfo(index, `birth_date`, `person_${index}_dtBorn`)}
                    value={data[`person_${index}_dtBorn`]}
                  />
                  {errors[`person_${index}_dtBorn`] &&
                  <p class={classes && classes.p_classes.error}>{i18n.t(errors[`person_${index}_dtBorn`])}</p>
                  }
                </Grid>
              </Grid>
              <Grid container  mb={1}   direction={"row"}  spacing={0}>
                <Grid item xs={5.9}>
                  <label class={classes && classes.label_classes}>{i18n.t('datePublicTransport')}</label>
                  <input
                    style={{ width: '100%' }}
                    class={classes && classes.input_classes.datePicker}
                    type="date"
                    placeholder={i18n.t('datePublicTransport')}
                    name="datePublicTransport"
                    min={new Date().toISOString().split('T')[0]}
                    max = {addDays(PUBLIC_TRANSPORT_LIMIT_DATE - 1).toISOString().split('T')[0]}
                    onChange={handleChangePersonInfo(index, `date_public_transport`, `person_${index}_date_public_transport`)}
                    onBlur={handleChangePersonInfo(index, `date_public_transport`, `person_${index}_date_public_transport`)}
                    value={data[`person_${index}_date_public_transport`]}
                  />
                  {errors[`person_${index}_date_public_transport`] &&
                  <p class={classes && classes.p_classes.error}>{i18n.t(errors[`person_${index}_date_public_transport`])}</p>
                  }
                </Grid>
              </Grid>
            </Grid>

                <Grid container   direction={"row"} mt={2}  mb={2} spacing={0}>
                  <p className={classes && classes.p_classes.regular}>
                    {i18n.t('buttomTitleDetailsScreen')}  <br/>{link} {i18n.t('personDetailsLinkSentence')}</p>

                </Grid>
              </Box>
            ))}
          </Grid>
          <Grid container alignItems={"flex-end"} justify="flex-end" item
                sm={12}>
            <Loading status={issueTicketsStatus}>
              <input   class={classes && classes.input_classes.submit} type="submit" value={i18n.t("createTicketButton")} />
            </Loading>
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
}

export default PersonalDetails
